const returnPathKey = "authentication.returnPath";

function isLocalPath(path) {
    return typeof path === "string" && /^\/(?!\/)[^\\?#\s]*$/.test(path);
}

function rememberLoginPath(storage, pathname) {
    // The registered root callback must not overwrite the original destination.
    // Store only a pathname, never OAuth callback parameters or tokens.
    if (pathname !== "/" && isLocalPath(pathname)) {
        storage.setItem(returnPathKey, pathname);
    }
}

function consumeLoginPath(storage) {
    const pathname = storage.getItem(returnPathKey);
    storage.removeItem(returnPathKey);
    return isLocalPath(pathname) ? pathname : null;
}

module.exports = { rememberLoginPath, consumeLoginPath };
